import { HeadingContent, Wrapper } from '../Banners.styles';

export default function WIPSubscribed() {
  return (
    <Wrapper>
      <HeadingContent>
        Pre-order to get first dibs when this car is available for purchase.
      </HeadingContent>
    </Wrapper>
  );
}
